/**
 * Veeso Auth API definitions
 */

import { defHTTP } from '../../api-builder';
import type {
  SendEmailVerificationRequest,
  SendEmailVerificationResponse,
  CheckCaptchaRequest,
  CheckCaptchaResponse,
  SendSmsCodeRequest,
  SendSmsCodeResponse,
  SignInRequest,
  SignInResponse,
  SignUpRequest,
  SignUpResponse,
} from './types';

/**
 * Auth API definitions for use with apiBuilder
 */
export const authAPIDefinitions = {
  /**
   * Send email verification code
   */
  sendEmailVerification: defHTTP<SendEmailVerificationRequest, SendEmailVerificationResponse>(
    'POST',
    '/account/send-email-verification'
  ),

  /**
   * Check if captcha is required for SMS
   */
  checkCaptcha: defHTTP<CheckCaptchaRequest, CheckCaptchaResponse>('POST', '/api/captcha/check'),

  /**
   * Send SMS verification code
   */
  sendSmsCode: defHTTP<SendSmsCodeRequest, SendSmsCodeResponse>('POST', '/account/send-sms-code'),

  /**
   * Sign in with email or phone
   */
  signIn: defHTTP<SignInRequest, SignInResponse>('POST', '/sign-in'),

  /**
   * Sign up with email or phone
   */
  signUp: defHTTP<SignUpRequest, SignUpResponse>('POST', '/sign-up'),
};

/**
 * Get Google OAuth URL for sign in
 * @param baseURL - API base URL
 * @param inviteCode - Optional invite code
 * @returns Google OAuth URL
 */
export function getGoogleOAuthURL(baseURL: string, inviteCode?: string): string {
  const params = new URLSearchParams();
  if (inviteCode) {
    params.set('inviteCode', inviteCode);
  }
  const queryString = params.toString();
  return `${baseURL}/auth/signin/google${queryString ? `?${queryString}` : ''}`;
}

/**
 * Get Google OAuth callback URL
 * @param baseURL - API base URL
 * @param inviteCode - Optional invite code
 * @returns Google OAuth callback URL
 */
export function getGoogleOAuthCallbackURL(baseURL: string, inviteCode?: string): string {
  const params = new URLSearchParams();
  if (inviteCode) {
    params.set('inviteCode', inviteCode);
  }
  const queryString = params.toString();
  return `${baseURL}${queryString ? `?${queryString}` : ''}`;
}
